import { render, staticRenderFns } from "./TextAlignmentsMobile.vue?vue&type=template&id=3463b965&scoped=true&"
import script from "./TextAlignmentsMobile.vue?vue&type=script&lang=ts&"
export * from "./TextAlignmentsMobile.vue?vue&type=script&lang=ts&"
import style0 from "./TextAlignmentsMobile.vue?vue&type=style&index=0&id=3463b965&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3463b965",
  null
  
)

export default component.exports